module.exports = __webpack_public_path__ + "static/img/nav_arrow_right.f9183fd.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/nav_arrow_right.svg
// module id = hZAm
// module chunks = 1